import axios from 'axios';

export const getCep = async (cep) => {
  const instance = axios.create({
    baseURL: 'https://viacep.com.br',
  });
  const response = await instance.get(`/ws/${cep}/json`);
  return response;
};
